export default "__VITE_ASSET__966cad58__"